import React, { Fragment, Component } from 'react';

import styles from './Modal.module.css';    // importing modules so that the styling doesn't interfere with themes on server
import Backdrop from '../../../UI/Backdrop/Backdrop';
import { connect } from 'react-redux';

class Modal extends Component {
	state = {
		showModal: this.props.showModal
	};

	hideModal = confirmed => {
		this.setState({ showModal: false });
		if (confirmed) this.props.confirmed();
		else this.props.hideModal();
	};

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) this.setState({ showModal: this.props.showModal });
	}

	render() {
		const modalImgSrc = '/wp-content/plugins/terabit-matrix-game/assets/images/mylearningmyway-logo1.png';
		const cancelBtnStyle = { display: `${this.props.hideCancelButton ? 'none' : 'inline-block'}` };
		const modalClass = `${styles.Modal} ${this.state.showModal ? styles.ShowModal : styles.HideModal}`;

		const modal = (
			<div className={modalClass}>
				<div className={styles.ModalBody}>
					<div>
						<img src={modalImgSrc} alt='MLMW_logo' className={styles.ModalLogo} />
						<div className={`${styles.ModalIcon} ${styles[this.props.currentApp]}`}>?</div>
					</div>
					<p className={styles.ModalText}>
						{this.props.modalBodyText}
					</p>
				</div>
				<div className={styles.ModalFooter}>
					<div className={styles.ButtonCancel} style={cancelBtnStyle} onClick={() => this.hideModal(false)} >
						No
					</div>
					<div className={`${styles.ButtonConfirm} ${styles[this.props.currentApp]}`} onClick={() => this.hideModal(true)}>
						{this.props.confirmationText}
					</div>
				</div>
			</div>
		);

		return (
			<Fragment>
				<Backdrop show={this.state.showModal} close={() => this.hideModal(false)} />
				{modal}
			</Fragment>
		);
	}
}

const mapStateToProps = state => ({
	currentApp: state.appReducer.currentApp
})

export default connect(mapStateToProps)(Modal);